import { useSelector } from 'react-redux';
import { useAppSelector } from '../../reducers';
import { activeCurrencySelector } from '../../selectors/CurrencySelectors';
import { groupedFeesByProductLevelSelector } from '../../selectors/PricingSelectors';
import { requiredOnboardingChoiceSkuIdsSelector } from '../../selectors/RequiredOnboardingSelectors';
import RequiredOnboardingSubtext from './RequiredOnboardingSubtext';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const RequiredOnboardingSubtextContainer = ({
  queryParamTerm,
  skuIds,
  tab,
  trackingSource,
  includesOnboardingCost = false
}) => {
  const activeCurrencyCode = useSelector(activeCurrencySelector);

  // Group fees by product level if possible
  const feesMap = useSelector(state => groupedFeesByProductLevelSelector(state, {
    skuIds,
    queryParamTerm
  }));
  const hasOnboardingChoices = useAppSelector(state => skuIds.some(skuId => requiredOnboardingChoiceSkuIdsSelector(state, {
    skuId
  })));
  if (hasOnboardingChoices && !includesOnboardingCost) {
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.requiredOnboardingSubtext.genericNotIncluded"
      })
    });
  }
  return /*#__PURE__*/_jsx(_Fragment, {
    children: Object.keys(feesMap).map(langKey => /*#__PURE__*/_jsx(RequiredOnboardingSubtext, {
      pricingInfo: feesMap[langKey],
      currencyCode: activeCurrencyCode,
      langKey: langKey,
      tab: tab,
      trackingSource: trackingSource,
      includesOnboardingCost: includesOnboardingCost
    }, langKey))
  });
};
export default RequiredOnboardingSubtextContainer;